// Models
/**
 * A view type that can carry saved customizations.
 */ export var TargetView = /*#__PURE__*/ function(TargetView) {
    TargetView["TaskGrid"] = "TaskGrid";
    TargetView["TaskBoard"] = "TaskBoard";
    TargetView["TaskTimeline"] = "TaskTimeline";
    TargetView["TaskCalendar"] = "TaskCalendar";
    return TargetView;
}({});
